import Vue from 'vue'
import VueRouter from 'vue-router'

import { setMiddlewares } from './middlewares'

import Home from '../views/Home.vue'
import Plants from '../views/Plants.vue'
import Schedule from '../views/Schedule.vue'
import Login from '../views/Login.vue'
import ResetPassword from '../views/ResetPassword.vue'
import SendEmailReset from '../views/SendEmailReset.vue'
import Map from '../views/Map.vue'
import Configuration from '../views/Configuration'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
		component: Home,
		meta: {
            requiresAuth: true
        },
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
    },
    {
        path: '/sendemail',
		name: 'SendEmailReset',
		component: SendEmailReset
    },
    {
        path: '/reset',
		name: 'ResetPassword',
		component: ResetPassword
    },
    {
        path: '/map',
        name: 'Map',
        component: Map,
        meta: {
            requiresAuth: true,
            title: 'Mapa',
            expandSidebar: true
        },
    },
    {
        path: '/plants',
        name: 'Plant',
        component: Plants,
        meta: {
            requiresAuth: true,
            title: 'Dashboard',
            expandSidebar: true
        },
    },
    {
        path: '/schedule/:id',
        name: 'Schedule',
        component: Schedule,
        meta: {
            requiresAuth: true,
            title: 'Horarios'
        },
    },
    {
        path: '/configuration',
        name: 'Configuration',
        component: Configuration,
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach(setMiddlewares)

export default router
